import script from "./ConsultantDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultantDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ConsultantDashboard.vue?vue&type=style&index=0&id=72030c47&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72030c47"]])

export default __exports__